
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/librarians",
      function () {
        return require("private-next-pages/librarians.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/librarians"])
      });
    }
  